import { useTranslation } from "react-i18next";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * Add manual as the LAST item of the manuals view (owner 2026-11-02): a dashed tile in the grid, a row in the list. No
 * orange fill, it would outweigh the manuals; the orange circle keeps the "adds content" colour. Opens the create drawer (ADR-013).
 */
export function AddManualTile({ layout, onPress }: { layout: "grid" | "list"; onPress: () => void }) {
  const { t } = useTranslation();
  const list = layout === "list";
  return (
    <Button
      variant="ghost"
      onPress={onPress}
      className={cn(
        "w-full",
        // The list clips its overflow for the rounded corners, so the focus ring goes inside the row.
        list
          ? "h-auto min-h-14 justify-start gap-3 rounded-none px-3 focus-visible:ring-inset"
          : "border-border bg-background/50 hover:border-ring/60 hover:bg-background h-full min-h-40 flex-col gap-2 rounded-xl border-dashed transition-colors duration-150",
      )}
    >
      <span className={cn("bg-orange text-on-orange flex shrink-0 items-center justify-center rounded-full", list ? "size-6" : "size-9")}>
        <Plus aria-hidden="true" />
      </span>
      {t("manualManagement.toolbar.add")}
    </Button>
  );
}
